export default __webpack_public_path__ + "static/media/640_store05-en-mobile.840b584e.png";